'use client'
import { getCookies } from '@/libs/cookies'
import { useQuery } from '@tanstack/react-query'

type Props = {
  cookieName: string
}

export const useCookieHttpOnly = ({ cookieName }: Props) => {
  const { data: cookie, refetch } = useQuery({
    queryKey: ['cookie', cookieName],
    queryFn: async () => {
      const cookie = await getCookies(cookieName)
      return cookie
    },
    staleTime: 1000,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  })

  return {
    cookie: cookie,
    refetchCookie: refetch,
  }
}
